import axios from "@/axios";

export const namespaced = true;

export const state = {
  auditLog: [],
  loadingText: "Results Loading...",
  totalAuditLogCount : null
};

export const getters = {
  getAuditLog: (state) => {
    return state.auditLog;
  },
  getTotalAuditLogCount: (state) => {
    return state.totalAuditLogCount
  },
  auditLogLoadingText: (state) => {
    return state.loadingText;
  },
};

export const mutations = {
  SET_AUDIT_LOG(state, auditLog) {  
    state.auditLog = state.auditLog.concat(auditLog);
  },
  CLEAR_AUDIT_LOG(state) {
    state.auditLog = [];
  },
  SET_AUDIT_LOG_LENGTH(state , number){
    state.totalAuditLogCount = number
  },
  SET_AUDIT_LOG_LOADING_TEXT(state, text) {
    state.auditLogLoadingText = text;
  },
};

export const actions = {
  clearData({ commit }) {
    commit("CLEAR_AUDIT_LOG");
  },
  async fetchAuditLog({ commit }, orderId = 0) {
    if (orderId != 0) {
      await axios
        .get(`/api/auditlogs/${orderId}`)
        .then((res) => {
          if (res.data.length > 0) {
            commit("SET_AUDIT_LOG_LOADING_TEXT", "Audit Logs Loaded...");
            commit("SET_AUDIT_LOG", res.data);
          } else {
            commit("SET_AUDIT_LOG_LOADING_TEXT", "No Audit Logs Available!");
          }
        })
        .catch((err) => {
          //console.log(err); //not handelled
        });
    } else {
      commit("CLEAR_AUDIT_LOG");
      //commit("SET_AUDIT_LOG", DummyAuditData);
    }
  },
  async fetchAuditLogPagination({ commit }, apiInfo) {
    try {
      let res = await axios
      .get(`/api/auditlogs/pagination/${apiInfo.orderId}/${apiInfo.pageNumber}/${apiInfo.resultsPerPage}/${apiInfo.searchText}`)

      if(apiInfo.isClear) commit("CLEAR_AUDIT_LOG");
      
       // commit or return
       if (res.data.results.length > 0) {

      commit("SET_AUDIT_LOG_LOADING_TEXT", "Audit Logs Loaded...");
          commit("SET_AUDIT_LOG", res.data.results);
          commit("SET_AUDIT_LOG_LENGTH", res.data.recordCount)
      }  else {
        commit("SET_AUDIT_LOG_LOADING_TEXT", "No Audit Logs Available!");
      }
    } catch(err) {
      //console.log(err);
    }
  },
};
